// Pure helper - decides urgency level config based on remaining combo slots.
// Extracted from LandingPage.jsx to remove nested ternaries and ease testing.

export const COMBO_TOTAL_VAGAS = 100;

const URGENCY_CONFIGS = {
  'low': {
    bar: 'from-emerald-500 to-amber-500',
    text: 'text-emerald-300',
    badge: 'bg-emerald-500/15 border-emerald-500/30 text-emerald-300',
    buildLabel: (remaining) => `${remaining} vagas disponíveis · 1ª turma`,
  },
  'medium': {
    bar: 'from-amber-500 to-orange-500',
    text: 'text-amber-300',
    badge: 'bg-amber-500/15 border-amber-500/30 text-amber-300',
    buildLabel: (remaining) => `Restam apenas ${remaining} vagas · 1ª turma`,
  },
  'high': {
    bar: 'from-orange-500 to-red-500',
    text: 'text-orange-300',
    badge: 'bg-orange-500/15 border-orange-500/30 text-orange-300',
    buildLabel: (remaining) => `Últimas ${remaining} vagas — garanta a sua!`,
  },
  'critical': {
    bar: 'from-red-500 to-rose-600',
    text: 'text-red-300',
    badge: 'bg-red-500/15 border-red-500/30 text-red-200',
    buildLabel: (remaining) => `URGENTE: apenas ${remaining} vagas restantes!`,
  },
  'sold-out': {
    bar: 'from-slate-600 to-slate-700',
    text: 'text-slate-300',
    badge: 'bg-slate-700 border-slate-600 text-slate-300',
    buildLabel: () => 'Vagas esgotadas na 1ª turma — entre na lista de espera',
  },
};

export function getUrgencyLevel(remaining) {
  if (remaining === 0) return 'sold-out';
  if (remaining <= 10) return 'critical';
  if (remaining <= 25) return 'high';
  if (remaining <= 50) return 'medium';
  return 'low';
}

export function getUrgencyConfig(remaining) {
  const level = getUrgencyLevel(remaining);
  const cfg = URGENCY_CONFIGS[level];
  return {
    level,
    bar: cfg.bar,
    text: cfg.text,
    badge: cfg.badge,
    label: cfg.buildLabel(remaining),
  };
}

// Items LGPD por curso. Usados no Termo de Ciência e Consentimento.
export const CONSENT_ITEMS_BY_COURSE = {
  propaganda: [
    { key: 'image_voice', title: 'Exibição de voz e imagem (LGPD)', text: 'Tenho ciência, nos termos da Lei nº 13.709/2018 (LGPD), de que voz e imagem do(a) professor(a) e de eventuais participantes serão exibidas durante as aulas que adquiri, exclusivamente no âmbito do(s) curso(s) contratado(s), sem qualquer outra finalidade.' },
    { key: 'no_edit', title: 'Não-edição posterior do material', text: 'Estou ciente de que o material do curso não será editado posteriormente para remoção dessas exibições de voz e imagem.' },
    { key: 'access_period', title: 'Período de acesso às gravações', text: 'Estou ciente de que as aulas gravadas ficarão disponíveis até 31/12/2026, podendo o acesso ser encerrado após essa data sem direito a reembolso por esse motivo.' },
  ],
  digital: [
    { key: 'image_voice', title: 'Exibição de voz e imagem (LGPD)', text: 'Tenho ciência, nos termos da Lei nº 13.709/2018 (LGPD), de que voz e imagem do(a) professor(a) e de eventuais participantes serão exibidas durante as aulas ao vivo do Curso de Direito Digital e IA nas Campanhas de 2026, exclusivamente no âmbito do curso contratado, sem qualquer outra finalidade.' },
    { key: 'participation', title: 'Participação ao vivo — voz e imagem', text: 'Caso eu opte por participar das aulas ao vivo com câmera e/ou microfone abertos, autorizo que minha voz e imagem sejam captadas e utilizadas exclusivamente no curso. Reconheço que posso, a qualquer momento, manter câmera e microfone fechados, caso prefira não ter minha voz e imagem captadas.' },
    { key: 'no_edit', title: 'Não-edição posterior do material', text: 'Estou ciente de que o material do curso não será editado posteriormente para remoção das exibições de voz e imagem captadas durante as aulas ao vivo.' },
    { key: 'access_period', title: 'Período de acesso às gravações (somente Combo)', text: 'Estou ciente de que, na compra isolada do Direito Digital e IA, não há acesso às gravações — apenas alunos do Combo poderão assistir às gravações até 31/12/2026.' },
  ],
  combo: [
    { key: 'image_voice', title: 'Exibição de voz e imagem (LGPD)', text: 'Tenho ciência, nos termos da Lei nº 13.709/2018 (LGPD), de que voz e imagem do(a) professor(a) e de eventuais participantes serão exibidas durante as aulas (ao vivo e gravadas) dos cursos do Combo Eleições 2026, exclusivamente no âmbito dos cursos contratados, sem qualquer outra finalidade.' },
    { key: 'participation', title: 'Participação ao vivo — voz e imagem', text: 'Caso eu opte por participar das aulas ao vivo do Direito Digital e IA com câmera e/ou microfone abertos, autorizo que minha voz e imagem sejam captadas e utilizadas exclusivamente no curso. Reconheço que posso, a qualquer momento, manter câmera e microfone fechados, caso prefira não ter minha voz e imagem captadas.' },
    { key: 'no_edit', title: 'Não-edição posterior do material', text: 'Estou ciente de que o material do curso não será editado posteriormente para remoção das exibições de voz e imagem captadas durante as aulas ao vivo.' },
    { key: 'access_period', title: 'Período de acesso às gravações', text: 'Estou ciente de que as gravações dos cursos (Propaganda Clássica e Direito Digital e IA) ficarão disponíveis até 31/12/2026, podendo o acesso ser encerrado após essa data sem direito a reembolso por esse motivo.' },
  ],
};

export const COURSE_NAME = {
  propaganda: 'Propaganda Eleitoral Clássica',
  digital: 'Direito Digital e IA nas Campanhas de 2026',
  combo: 'Combo Eleições 2026',
};

export const PURCHASE_LINKS = {
  propaganda: 'https://www.asaas.com/c/h12ukb95r7d5h82e',
  digital: 'https://www.asaas.com/c/tdnb0u3aqu18lrx2',
  combo: 'https://www.asaas.com/c/leehxv5sny86qxko',
};
